'use client';
import React from 'react'
import OwlSlider from '@/components/OwlSlider';
import doctors from '@/data/doctors';
import { FaEye } from "react-icons/fa6";
import { FaRegCalendar } from "react-icons/fa6";
import Link from 'next/link';
import Image from 'next/image';

const Ourdoctors = () => {
  return (
    <div>
      <section className='our-doctors-section css-padding'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <div className='title-section text-centre'>
                <h2 className='css-heading'>
                  <span className='first-title'>Our</span>
                  <span className='second-title'> Doctors</span>
                </h2>
                <Image
                  src="/images/DNA.webp"
                  alt="DNA image"
                  width={67}
                  height={21}
                />
              </div>
              <OwlSlider
                items={doctors
                  .filter((doctor) => doctor.id !== 11)
                  .map((doctor) => (
                    <div className="p-2" key={doctor.id}>
                      <div className="doctor-card">
                        <div className="doctor-top">
                          <div className="doc-imageContainer with-bg">
                            <Image
                              src={doctor.image}
                              alt={doctor.alt}
                              width={291}
                              height={195}
                              className="css-doc-image img-fluid w-100"
                              style={{ width: "100%", height: "auto" }}
                            />
                          </div>
                          <a href="tel:+918544015151" className='apt-btn-css-underline'>
                            <button className="appointment-button">
                              <FaRegCalendar /> Appointment Now
                            </button>
                          </a>
                        </div>
                        <div className="doctor-bottom doctorInfo css-doc-height">
                          <div>
                            <div className="doc-name">{doctor.name}</div>
                            <div className="doc-speciality">{doctor.speciality}</div>
                          </div>
                          <Link href={`/our-doctors/${doctor.slug}`} className="css-doc-arrowBtn" aria-label='Right Arrow'>
                            <FaEye />
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                itemsPerView={{
                  0: 1,
                  768: 2,
                  991: 3,
                  1400: 4,
                }}
                autoplay={true}
                autoplayInterval={4000}
                nav={true}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Ourdoctors
